import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import Link from '@/components/UI/Link';
import SearchFilterBar from '@/components/UI/SearchFilterBar';
import Table from '@/components/UI/Table';
import { filterDataBySearch } from '@/components/UI/Table/Table.utils';
import { useState } from 'react';
import { TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';
import { FC } from 'react';

interface Template {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

interface TemplatesTableProps {
  templates: Array<Template>;
}

const columns: Array<TanStackColumnDef<Template>> = [
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: Template } }) => {
      return (
        <Link className="blue link normal lh-copy underline-hover" to={`/tasks/templates/${original.id}`}>
          {original.name}
        </Link>
      );
    },
  },
  {
    id: 'createdAt',
    header: 'Created',
    accessorKey: 'created_at',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: Template } }) => (
      <DateTimeRenderer value={original.created_at} defaultResponse="-" />
    ),
  },
  {
    id: 'updateAt',
    header: 'Updated',
    accessorKey: 'updated_at',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: Template } }) => (
      <DateTimeRenderer value={original.updated_at} defaultResponse="-" />
    ),
  },
];

const TemplatesTable: FC<TemplatesTableProps> = ({ templates }) => {
  const [searchQuery, setQuery] = useState('');

  let data: Array<Template> = templates.map((t) => {
    return {
      id: t.id,
      name: t.name,
      created_at: t.created_at,
      updated_at: t.updated_at,
    };
  });

  if (searchQuery !== '') {
    data = filterDataBySearch(data, searchQuery);
  }

  return (
    <>
      <div className="pa3">
        <SearchFilterBar
          searchPlaceholderText="Search by template name"
          handleSearchInput={setQuery}
          searchQuery={searchQuery}
        />
      </div>
      <div className="ui__table">
        <Table data={data} columns={columns} />
      </div>
    </>
  );
};

export default TemplatesTable;
